import { useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Logo from "@/components/base/Logo";

export default function Login() {
  const { t } = useTranslation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [remember, setRemember] = useState(false);
  const [showPass, setShowPass] = useState(false);
  const [finModal, setFinModal] = useState(false);
  const [finNum, setFinNum] = useState("");
  const [finPass, setFinPass] = useState("");
  const [showFinPass, setShowFinPass] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
  };

  const handleFinSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setFinModal(false);
  };

  return (
    <div className="min-h-screen bg-stone-50">
      <Navbar />
      <div className="pt-16 min-h-screen flex items-center justify-center px-4 py-14">
        <div className="w-full max-w-md">
          {/* Card */}
          <div className="bg-white rounded-2xl p-8 md:p-10">
            {/* Logo */}
            <div className="flex flex-col items-center mb-7">
              <div className="mb-3">
                <Logo variant="dark" size="lg" />
              </div>
              <h1 className="text-xl font-bold text-gray-900">{t("login.title")}</h1>
              <p className="text-gray-400 text-sm mt-1">{t("login.subtitle")}</p>
            </div>

            <form onSubmit={handleSubmit} className="space-y-4">
              {/* Email */}
              <div>
                <label className="text-xs font-medium text-gray-600 mb-1 block">{t("login.email")}</label>
                <div className="relative">
                  <i className="ri-mail-line absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 text-sm" />
                  <input
                    type="email"
                    name="email"
                    required
                    placeholder={t("login.email_placeholder")}
                    className="w-full border border-gray-200 rounded-lg pl-9 pr-4 py-2.5 text-sm text-gray-800 outline-none focus:border-red-500 transition-colors bg-white"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </div>
              </div>

              {/* Password */}
              <div>
                <label className="text-xs font-medium text-gray-600 mb-1 block">{t("login.password")}</label>
                <div className="relative">
                  <i className="ri-lock-2-line absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 text-sm" />
                  <input
                    type={showPass ? "text" : "password"}
                    name="password"
                    required
                    placeholder={t("login.password_placeholder")}
                    className="w-full border border-gray-200 rounded-lg pl-9 pr-10 py-2.5 text-sm text-gray-800 outline-none focus:border-red-500 transition-colors bg-white"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                  <button
                    type="button"
                    onClick={() => setShowPass(!showPass)}
                    className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 cursor-pointer"
                  >
                    <i className={showPass ? "ri-eye-off-line" : "ri-eye-line"} />
                  </button>
                </div>
              </div>

              {/* Remember + Forgot */}
              <div className="flex items-center justify-between">
                <label className="flex items-center gap-2 text-sm text-gray-600 cursor-pointer">
                  <input
                    type="checkbox"
                    className="accent-red-600 cursor-pointer"
                    checked={remember}
                    onChange={(e) => setRemember(e.target.checked)}
                  />
                  {t("login.remember")}
                </label>
                <a href="#" rel="nofollow" className="text-sm text-red-600 hover:text-red-700 cursor-pointer">
                  {t("login.forgot")}
                </a>
              </div>

              {/* Login Button */}
              <button
                type="submit"
                className="w-full bg-red-600 hover:bg-red-700 text-white font-semibold py-3 rounded-lg text-sm cursor-pointer transition-all whitespace-nowrap mt-1"
              >
                {t("login.btn")}
              </button>
            </form>

            {/* Divider */}
            <div className="flex items-center gap-3 my-5">
              <div className="flex-1 h-px bg-gray-100" />
              <span className="text-xs text-gray-400">{t("login.or")}</span>
              <div className="flex-1 h-px bg-gray-100" />
            </div>

            {/* FIN Login */}
            <button
              onClick={() => setFinModal(true)}
              className="w-full border border-gray-200 hover:border-red-400 text-gray-700 hover:text-red-600 font-medium py-2.5 rounded-lg text-sm cursor-pointer transition-all whitespace-nowrap flex items-center justify-center gap-2"
            >
              <i className="ri-id-card-line" />
              {t("login.fin_btn")}
            </button>

            {/* Register Link */}
            <p className="text-center text-sm text-gray-500 mt-6">
              {t("login.no_account")}{" "}
              <Link to="/register" className="text-red-600 font-medium cursor-pointer hover:text-red-700">
                {t("login.register_link")}
              </Link>
            </p>

            {/* SSL Badge */}
            <div className="flex items-center justify-center gap-1.5 mt-5 text-xs text-gray-400">
              <i className="ri-shield-check-line text-green-500" />
              {t("login.secure")}
            </div>
          </div>
        </div>
      </div>
      <Footer />

      {/* FIN Modal */}
      {finModal && (
        <div className="fixed inset-0 bg-black/40 z-50 flex items-center justify-center px-4">
          <div className="bg-white rounded-2xl p-8 w-full max-w-sm">
            <div className="flex items-start justify-between mb-5">
              <div>
                <h3 className="font-bold text-gray-900 text-lg">{t("login.fin_modal_title")}</h3>
                <p className="text-xs text-gray-400 mt-0.5">{t("login.fin_modal_desc")}</p>
              </div>
              <button
                onClick={() => setFinModal(false)}
                className="text-gray-400 hover:text-gray-700 cursor-pointer w-7 h-7 flex items-center justify-center"
              >
                <i className="ri-close-line text-lg" />
              </button>
            </div>
            <form onSubmit={handleFinSubmit} className="space-y-4">
              <div>
                <label className="text-xs font-medium text-gray-600 mb-1 block">{t("login.fin_modal_fin")}</label>
                <input
                  type="text"
                  name="fin"
                  required
                  maxLength={7}
                  className="w-full border border-gray-200 rounded-lg px-3.5 py-2.5 text-sm outline-none focus:border-red-500 transition-colors"
                  value={finNum}
                  onChange={(e) => setFinNum(e.target.value.replace(/\D/g, ""))}
                />
              </div>
              <div>
                <label className="text-xs font-medium text-gray-600 mb-1 block">{t("login.fin_modal_pass")}</label>
                <div className="relative">
                  <input
                    type={showFinPass ? "text" : "password"}
                    name="finPassword"
                    required
                    className="w-full border border-gray-200 rounded-lg px-3.5 py-2.5 pr-10 text-sm outline-none focus:border-red-500 transition-colors"
                    value={finPass}
                    onChange={(e) => setFinPass(e.target.value)}
                  />
                  <button
                    type="button"
                    onClick={() => setShowFinPass(!showFinPass)}
                    className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 cursor-pointer"
                  >
                    <i className={showFinPass ? "ri-eye-off-line" : "ri-eye-line"} />
                  </button>
                </div>
              </div>
              <button
                type="submit"
                className="w-full bg-red-600 hover:bg-red-700 text-white font-semibold py-2.5 rounded-lg text-sm cursor-pointer transition-all whitespace-nowrap"
              >
                {t("login.fin_modal_btn")}
              </button>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
